httpMethodType